import React, { Component, PropTypes } from 'react';
import ClassNames from 'classnames';

export default class RadialSVGProgressBar extends Component {
  static propTypes = {
    amount: PropTypes.number,
    size: PropTypes.number,
    strokeWidth: PropTypes.number,
    backgroundStrokeWidth: PropTypes.number,
    strokeBackground: PropTypes.string,
    strokeColor: PropTypes.string,
    label: PropTypes.bool,
    overlay: PropTypes.bool
  };

  static defaultProps = {
    size: 100,
    strokeWidth: 2,
    backgroundStrokeWidth: 2,
    label: true,
    overlay: false,
    overlayBackground: 'rgba(30, 30, 30, 0.5)',
    strokeBackground: 'rgba(30, 30, 30, 0.1)',
    strokeColor: '#FFF'
  };

  constructor() {
    super(arguments);
    this.state = {
      amount: 0,
      transition: 'stroke-dashoffset 1s linear'
    };
  }

  componentDidMount() {
    this.setState({ amount: this.props.amount || 0 });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.amount) {
      this.setState({
        amount: nextProps.amount,
        transition: 'stroke-dashoffset 0.1s linear'
      });
    }
  }

  render(e) {
    const width = this.props.size;
    const height = this.props.size;
    const stroke = this.props.strokeColor;
    const strokeWidth = this.props.strokeWidth;
    const backgroundStrokeWidth = this.props.backgroundStrokeWidth;
    const strokeBackground = this.props.strokeBackground;
    let overlayStyle = {};
    let bgStyle;
    let style;
    let progressBar = null;
    let r = width / 2 - strokeWidth;
    let c = Math.PI * (r * 2);
    let text = null;
    let percent = (100 - this.state.amount) / 100 * c;
    bgStyle = Object.assign(
      {},
      {
        strokeDashoffset: 0,
        fill: 'transparent',
        transition: this.state.transition,
        transform: 'rotate(-90 ' + width / 4 + ' ' + height / 4 + ')',
        stroke: strokeBackground,
        strokeWidth: backgroundStrokeWidth
      }
    );
    style = Object.assign(
      {},
      {
        strokeDashoffset: percent,
        fill: 'transparent',
        transition: this.state.transition,
        stroke: stroke,
        strokeWidth: strokeWidth
      }
    );
    overlayStyle = Object.assign(
      {},
      {
        backgroundColor: this.props.overlayBackground,
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        textAlign: 'center',
        paddingTop: height / 4,
        bottom: 0
      }
    );
    if (this.props.label && this.state.amount > 0) {
      text = (
        <text
          x={width / 2}
          y={height / 2}
          fontSize={width / 4}
          fill={stroke}
          textAnchor="middle"
          style={{ alignmentBaseline: 'middle' }}
        >
          {Math.round(this.state.amount)}
        </text>
      );
    }
    progressBar = (
      <svg
        style={Object.assign({}, this.props.style)}
        className={ClassNames('radial-progress', this.props.className)}
        width={width}
        height={height}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          r={r}
          cx={width / 2}
          cy={height / 2}
          style={bgStyle}
          transform={'rotate(-90 ' + width / 2 + ' ' + height / 2 + ')'}
        />
        <circle
          r={r}
          cx={width / 2}
          cy={height / 2}
          style={style}
          strokeDasharray={c}
          transform={'rotate(-90 ' + width / 2 + ' ' + height / 2 + ')'}
        />
        {text}
      </svg>
    );
    if (this.props.overlay) {
      return <div style={overlayStyle}>{progressBar}</div>;
    } else {
      return progressBar;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/RadialSVGProgressBar.js